import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogHeader,
  DialogBody,
  DialogFooter,
  Spinner,
} from "@material-tailwind/react";
import { Modal, Upload, Input } from "antd";
import {
  db,
  collection,
  addDoc,
  getDocs,
  ref,
  uploadBytes,
  storage,
  getDownloadURL,
  setDoc,
  doc,
} from "../../config/firebase";
import Swal from "sweetalert2";
import Img from "../../Asset/Online Course Web Batch 2.jpg";
import TestPdf from "./pdf";
import "./style.css";
import { getDoc, onSnapshot, serverTimestamp } from "firebase/firestore";
import { PatternFormat } from "react-number-format";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { BestPdf } from "./BestPdf";

const { Search } = Input;

const defaultSearchCardData = {
  error: false,
  message: null,
  data: null,
};

export default function Form() {
  const [open, setOpen] = useState(false);
  const [selectedGender, setSelectedGender] = useState("");
  const [selectedCourse, setSelectedCourse] = useState("");
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [previewTitle, setPreviewTitle] = useState("");
  const [fileList, setFileList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const [searchedCard, setSearchedCard] = useState(defaultSearchCardData);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    fname: "",
    city: "",
    cnic: "",
    phone: "",
    dob: "",
    qualification: "",
    address: "",
    gender: "",
    batch: "02",
    course: "",
  });

  const handleOpen = () => {
    setOpen(!open);
    setSearchedCard(defaultSearchCardData);
  };
  

  const handleCancel = () => setPreviewOpen(false);

  const handlePreview = async (file) => {
    const preview = file.url || (await getBase64(file.originFileObj));
    setPreviewImage(preview);
    setPreviewOpen(true);
    setPreviewTitle(file.name || file.url.substring(file.url.lastIndexOf("/") + 1));
  };
  

  const handleChange = ({ fileList: newFileList }) => {
    setFileList(newFileList.slice(-1)); // Keep only the last file in the list
    updateDisabledState();
  };
  

  const handleGenderChange = (event) => {
    setSelectedGender(event.target.value);
  };
  const handleCourseChange = (event) => {
    setSelectedCourse(event.target.value);
  };

  // const handleInputChange = (e) => {
  //   const { name, value } = e.target;
  
  //   // Convert the first character to uppercase and the rest to lowercase
  //   const formattedValue = (name === "name" || name === "fname") ? 

  //     value.charAt(0).toUpperCase() + value.slice(1).toLowerCase() : value;
  
  //   setFormData({
  //     ...formData,
  //     [name]: formattedValue,
  //   });
  
  //   updateDisabledState(); // Update the disabled state based on form validation
  // };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    // Convert the first character of every word to uppercase and the rest to lowercase
    let formattedValue;
    if (name === "name" || name === "fname") {
        formattedValue = value
            .split(/\s+/) // Split by any whitespace character
            .map(word => {
               
                    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
                
            })
            .join(' ');
    } else {
        formattedValue = value;
    }

    // Set formatted value in form data
    setFormData({
      ...formData,
      [name]: formattedValue,
    });

    // Update the disabled state based on form validation
    updateDisabledState();
};

  
  const handleSubmit = async () => {
    setLoading(true);
    updateDisabledState();
  
    const { name, email, fname, city, cnic, phone, dob, qualification, address, gender, batch, course } = formData;
  
    const requiredFields = [name, email, fname, city, cnic, phone, dob, qualification, address, gender, course];
    const missingField = requiredFields.find(field => !field);
  
    if (missingField) {
      Swal.fire({
        icon: "error",
        title: "Fields are required.",
        text: "Please fill out all fields and upload a picture.",
      });
      setLoading(false);
      return;
    }
  
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailPattern.test(email)) {
      Swal.fire({
        icon: "error",
        title: "Invalid Email Address.",
      });
      setLoading(false);
      return;
    }
  
    const cnicPattern = /^[0-9]{5}-[0-9]{7}-[0-9]{1}$/;
    if (!cnicPattern.test(cnic)) {
      Swal.fire({
        icon: "error",
        title: "Invalid CNIC",
        text: "CNIC should be in the format 12345-1234567-1",
      });
      setLoading(false);
      return;
    }
  
    let random;
    do {
      random = Math.floor(Math.random() * 9000 + 1000);
      const rollNumberSnapshot = await getDocs(collection(db, "rollnumber"));
      if (!rollNumberSnapshot.docs.some(doc => doc.data().roll === random)) break;
    } while (true);
  
    try {
      const docRef = await addDoc(collection(db, "rollnumber"), { roll: random });
      const storageRef = ref(storage, `images/${docRef.id}`);
      await uploadBytes(storageRef, fileList[0].originFileObj);
      const url = await getDownloadURL(ref(storage, `images/${docRef.id}`));
  
      await setDoc(doc(db, "Students", docRef.id), {
        name, email, fname, city, cnic, phone, DateOfBirth: dob, qualification, address, gender,
        status: "pending", rollNumber: random, date: serverTimestamp(), id: docRef.id, pic: url,
        batch, course
      });
  
      const std = { uid: docRef.id, pic: url };
      localStorage.setItem("Student", JSON.stringify(std));
      setLoading(false);
  
      // Reset form fields
      setFormData({ name: "", email: "", fname: "", city: "", cnic: "", phone: "", dob: "", qualification: "", address: "", gender: "" });
      setFileList([]);
      setOpen(true);
    } catch (e) {
      console.error("Error adding document: ", e);
      setLoading(false);
    }
  };
  

  const updateDisabledState = () => {
    const { name, email, fname, city, cnic, phone, dob, qualification, address, gender, course } = formData;
    const isFormComplete = [name, email, fname, city, cnic, phone, dob, qualification, address, gender, course].every(field => field);
    setDisabled(!isFormComplete || !fileList[0]);
  };
  

  const getBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

const file = fileList[0]?.originFileObj;
if (file instanceof Blob) {
  getBase64(file)
    .then((base64String) => {
      localStorage.setItem("uPic", base64String);
    })
    .catch((error) => {
      console.error("Error reading file:", error);
    });
} else {
  console.error("Invalid file or file not found.");
}


  async function handleClickSearch(searchTerm) {
    try {
      const q = collection(db, "Students");
      const snapshot = await getDocs(q);
      const newData = snapshot.docs.map(doc => doc.data());
      
      const searchCard = newData.find(data => data.email === searchTerm);
      if (searchCard) {
        console.log(searchCard);
    
      } else {
        console.log("Cannot find the card with this email");
    
      }
    } catch (error) {
      console.error("Error", error);
    }
  }
  

  let img = localStorage.getItem("uPic");

  return (
    <>
      {/* <BestPdf
        /> */}
      <div
        id="loader"
        className={`fixed top-0 left-0 flex items-center bg-gray-800 opacity-60 z-50 w-full h-screen z-50 ${
          loading ? "block" : "hidden"
        }`}
      >
        <div className="flex justify-center w-full">
          <Spinner
            className="h-32 w-32 sm:h-48 sm:w-48 md:h-64 md:w-64 lg:h-80 lg:w-20 z-50 text-gray-900/50"
            color="green"
          />
        </div>
      </div>
      <div>
        <div className="flex w-full mt-12">
          <div className="w-full">
            <h1
              style={{ backgroundColor: "#0B5F68", height: "80px" }}
              className="sm:text-3xl text-white text-center text-2xl font-bold title-font mb-4 text-gray-900 pt-5"
            >
              Course Registration Form
            </h1>
            <p
              className="lg:w-2/3 mx-auto text-center font-bold text-green-600  leading-relaxed text-base"
              style={{ fontSize: "20px", color: "#0B5F68" }}
            >
              Service-Education-Registration
            </p>
            <div className="flex justify-evenly ml-4">
              {/* <div style={{ width: "350px" }}>
                <Search
                  type="email"
                  placeholder="Enter cnic"
                  enterButton="Search"
                  size="large"
                  // loading
                  pattern="#####-#######-#"
                  onSearch={handleClickSearch}
                  className="search-input"
                />
                {searchedCard.error && (
                  <p>{searchedCard.message || "Card not found"}</p>
                )}
              </div> */}
              <a
                c
                href="../payment"
                style={{
                  marginRight: "10%",
                  fontSize: "15px",
                  backgroundColor: "#0B5F68",
                  padding: "10px",
                  color: "white",
                  borderRadius: "10px",
                }}
                className="w-1/8"
              >
                Payment Verify
              </a>
              <a
                c
                href="../download"
                style={{
                  // marginRight: "10%",
                  fontSize: "15px",
                  backgroundColor: "#0B5F68",
                  padding: "10px",
                  color: "white",
                  borderRadius: "10px",
                }}
                className="w-1/8"
              >
                Download ID Card
              </a>
            </div>
          </div>
        </div>

        <section className="text-gray-600 body-font relative">
          <div className="container px-5 mx-auto">
            <br />
            <div className="lg:w-1/2 md:w-2/3 mx-auto">
              <div className="w-full">
                <img src={Img} alt="" className="w-full h-64 rounded-xl" />
              </div>
              <br />
              <br />
              <div className="flex flex-wrap -m-2">
                <div className="p-2 w-1/2">
                  <div className="relative">
                    <label
                      htmlFor="name"
                      className="leading-7 text-sm text-gray-600"
                    >
                      Full Name
                    </label>
                    <input
                      type="text"
                      placeholder="Full Name"
                      id="name"
                      name="name"
                      className="w-full bg-gray-100 bg-opacity-50 rounded border border-gray-300 focus:border-indigo-500 focus:bg-white focus:ring-2 focus:ring-indigo-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
                      value={formData.name}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>

                <div className="p-2 w-1/2">
                  <div className="relative">
                    <label
                      htmlFor="fname"
                      className="leading-7 text-sm text-gray-600"
                    >
                      Father Name
                    </label>
                    <input
                      type="text"
                      placeholder="Father Name"
                      id="fname"
                      name="fname"
                      className="w-full bg-gray-100 bg-opacity-50 rounded border border-gray-300 focus:border-indigo-500 focus:bg-white focus:ring-2 focus:ring-indigo-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
                      value={formData.fname}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>

                <div className="p-2 w-1/2">
                  <div className="relative">
                    <label
                      htmlFor="email"
                      className="leading-7 text-sm text-gray-600"
                    >
                      Email
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      placeholder="Email"
                      className="w-full bg-gray-100 bg-opacity-50 rounded border border-gray-300 focus:border-indigo-500 focus:bg-white focus:ring-2 focus:ring-indigo-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
                      value={formData.email}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>

                <div className="p-2 w-1/2">
                  <div className="relative">
                    <label
                      htmlFor="city"
                      className="leading-7 text-sm text-gray-600"
                    >
                      City
                    </label>
                    <input
                      type="text"
                      placeholder="City"
                      id="city"
                      name="city"
                      className="w-full bg-gray-100 bg-opacity-50 rounded border border-gray-300 focus:border-indigo-500 focus:bg-white focus:ring-2 focus:ring-indigo-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
                      value={formData.city}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
                <div className="p-2 w-1/2">
                  <div className="relative">
                    <label
                      htmlFor="cnic"
                      className="leading-7 text-sm text-gray-600"
                    >
                      CNIC / B-Form
                    </label>
                    <PatternFormat
                      placeholder="00000-0000000-0"
                      mask="-"
                      format="#####-#######-#"
                      id="cnic"
                      name="cnic"
                      className="w-full input_num bg-gray-100 bg-opacity-50 rounded border border-gray-300 focus:border-indigo-500 focus:bg-white focus:ring-2 focus:ring-indigo-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
                      value={formData.cnic}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>

                <div className="p-2 w-1/2">
                  <div className="relative">
                    <label
                      htmlFor="phone"
                      className="leading-7 text-sm text-gray-600"
                    >
                      Phone
                    </label>
                    <PatternFormat
                      placeholder="0000-0000000"
                      id="phone"
                      name="phone"
                      className="w-full input_num bg-gray-100 bg-opacity-50 rounded border border-gray-300 focus:border-indigo-500 focus:bg-white focus:ring-2 focus:ring-indigo-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
                      format="####-#######"
                      mask="-"
                      value={formData.phone}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>

                <div className="p-2 w-1/2">
                  <div className="relative">
                    <label
                      htmlFor="dob"
                      className="leading-7 text-sm text-gray-600"
                    >
                      Date of Birth
                    </label>
                    <input
                      type="date"
                      placeholder="Date of birth"
                      id="dob"
                      name="dob"
                      className="w-full bg-gray-100 bg-opacity-50 rounded border border-gray-300 focus:border-indigo-500 focus:bg-white focus:ring-2 focus:ring-indigo-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
                      value={formData.dob}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
                <div className="p-2 w-1/2">
                  <div className="relative">
                    <label className="leading-7 text-sm text-gray-600">
                      Gender
                    </label>
                    <div className="w-full">
                      <select
                        id="gender"
                        name="gender" // Add the name attribute for the select element
                        value={formData.gender}
                        onChange={handleInputChange} // Use the handleInputChange function
                        className="w-full bg-gray-100 bg-opacity-50 rounded border border-gray-300 focus:border-indigo-500 focus:bg-white focus:ring-2 focus:ring-indigo-200 text-base outline-none text-gray-700 py-2 px-3 transition-colors duration-200 ease-in-out"
                      >
                        <option value="">Select Gender</option>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div className="p-2 w-1/2">
                  <div className="relative">
                    <label className="leading-7 text-sm text-gray-600">
                      Select Course
                    </label>
                    <div className="w-full">
                      <select
                        id="course"
                        name="course" // Add the name attribute for the select element
                        value={formData.course}
                        onChange={handleInputChange} // Use the handleInputChange function
                        className="w-full bg-gray-100 bg-opacity-50 rounded border border-gray-300 focus:border-indigo-500 focus:bg-white focus:ring-2 focus:ring-indigo-200 text-base outline-none text-gray-700 py-2 px-3 transition-colors duration-200 ease-in-out"
                      >
                        <option value="">Select Course</option>
                        <option value="Technology For Kids">Technology For Kids</option>
                        <option value="Web Crash Course">Web Crash Course</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div className="p-2 w-1/2">
                  <div className="relative">
                    <label
                      htmlFor="qualification"
                      className="leading-7 text-sm text-gray-600"
                    >
                      Qualification
                    </label>
                    <input
                      type="text"
                      placeholder="Qualification"
                      id="qualification"
                      name="qualification"
                      className="w-full bg-gray-100 bg-opacity-50 rounded border border-gray-300 focus:border-indigo-500 focus:bg-white focus:ring-2 focus:ring-indigo-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
                      value={formData.qualification}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>

                <div className="p-2 w-full">
                  <div className="relative">
                    <label
                      htmlFor="Address"
                      className="leading-7 text-sm text-gray-600"
                    >
                      Address
                    </label>
                    <input
                      type="text"
                      placeholder="Address"
                      id="address"
                      name="address"
                      className="w-full bg-gray-100 bg-opacity-50 rounded border border-gray-300 focus:border-indigo-500 focus:bg-white focus:ring-2 focus:ring-indigo-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
                      value={formData.address}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
                <div className="p-2 w-full">
                  <div className="relative">
                    <label
                      htmlFor="Address"
                      className="leading-7 text-sm text-gray-600"
                    >
                      Picture
                    </label>
                    <Upload
                      action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                      listType="picture-card"
                      fileList={fileList}
                      onPreview={handlePreview}
                      onChange={handleChange}
                      class="hidden"
                      id="img"
                      style={{ border: "none" }}
                    >
                      {fileList.length === 0 && "Upload"}{" "}
                      {/* Corrected condition */}
                    </Upload>
                    <Modal
                      open={previewOpen}
                      title={previewTitle}
                      footer={null}
                      onCancel={handleCancel}
                    >
                      <img
                        alt="example"
                        style={{
                          width: "100%",
                        }}
                        src={previewImage}
                      />
                    </Modal>
                  </div>
                </div>
                <div className="flex justify-center  w-full">
                  <Button
                    style={{ backgroundColor: "#0B5F68" }}
                    className=" flex justify-center "
                    onClick={handleSubmit}
                    id="btnsubmit"
                    disabled={disabled} // Disable the button based on the disabled state
                  >
                    Submit
                  </Button>
                </div>
                <div className="p-2 w-full">
                  <Dialog
                    open={open}
                    handler={handleOpen}
                    animate={{
                      mount: { scale: 1, y: -30 },
                      unmount: { scale: 0.9, y: -100 },
                    }}
                  >
                    <DialogHeader
                      className="text-white"
                      style={{ backgroundColor: "#0B5F68" }}
                    >
                      <div className="flex justify-between  w-full">
                        <div>
                          <h1>Form Submit Successfully </h1>
                        </div>
                        <div>
                          <Button
                            variant="text"
                            color="red"
                            onClick={handleOpen}
                            className="text-end mr-1"
                          >
                            <FontAwesomeIcon
                              size="2xl"
                              icon={faXmark}
                              style={{ color: "#ffffff" }}
                            />
                          </Button>
                        </div>
                      </div>
                    </DialogHeader>
                    <DialogBody divider>
                      <TestPdf
                        style={{
                          width: "100%",
                          height: "100px",
                          border: "1px solid #ccc",
                        }}
                      ></TestPdf>
                    </DialogBody>
              
                    <DialogFooter>
                    {console.log(formData.course, "=====> slect this course")}
                    
                      <p className="text-black font-bold text-xl">
                        Congratulations! Ap Ki Registration
                        Batch 2 Course Main Hogai Hai. Please Registration Ko
                        Confirm Kernay K Lye Apni Fee Rs:3000/= Pay Karen.
                        <br />
                        <h1
                          style={{
                            marginRight: "10%",
                            fontSize: "24px",
                            // backgroundColor: "#0B5F68",
                            padding: "10px 0px",
                            color: "#0B5F68",
                            borderRadius: "10px",
                            // textAlign: 'center'
                          }}
                        >
                          Online Via Easy Paisa:
                        </h1>
                        Account Title: Muhammad Rizwan
                        <br />
                        Mobile Number: 0343-4192648
                        <br />
                        Further Details Ke Liye Is Number Per Contact Kare +92-343-4192648
                      </p>
                    </DialogFooter>
                  </Dialog>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
